import { Outlet } from "react-router"
import Team from "./team"
import Head from "../components/head"

export default function Teams() {
  return (
    <>
      <Head
        headName="The Team"
        subHeadName={`Meet the LIMIT ${new Date().getFullYear()} Team 😄`}
      />
      <Team sx={{ mt: 4 }} />
      <Outlet />
    </>
  )
}
